import { Field, Validations } from '../../../components/Form';

export const getFieldsFromObject = (
  obj: Record<string, any>,
  parentError: Record<string, any>,
  setUser: React.Dispatch<React.SetStateAction<any>>,
  parentKey?: string,
) => {
  const fields: Array<Field> = [];

  const entries = Object.entries(obj);

  entries.map(([key, value], index) => {
    const handleValueChange = (v: string) => {
      setUser({
        ...obj,
        [key]: v,
      });
    };

    if (typeof value === 'object' && value !== null) {
      /** Re-run */
      fields.push(
        ...getFieldsFromObject(value, parentError, handleValueChange, key),
      );
    } else {
      /** Add */
      fields.push({
        label: key,
        value: obj[key],
        handleValueChange: handleValueChange,
        error: parentError[key],
        ...(!!parentKey &&
          entries.length > 1 &&
          index === 0 && { title: parentKey }),
      });
    }
  });

  return fields;
};

export const formatParam = (value: string | undefined) => {
  if (value === null) {
    return null;
  }

  if (typeof value === 'undefined') {
    return undefined;
  }

  const numberValue = parseFloat(value);

  if (isNaN(numberValue) || numberValue.toString().length !== value.length) {
    return value;
  }

  return numberValue;
};

export const formatObjectFields = (obj: Record<string, any>) => {
  Object.entries(obj).map(([key, value]) => {
    if (typeof value === 'object' && value !== null) {
      formatObjectFields(value);
    } else {
      obj[key] = formatParam(value);
    }
  });

  return obj;
};

export const checkIsRequired = (
  value: string | undefined,
  setErrors: React.Dispatch<React.SetStateAction<Record<string, Validations>>>,
  label: string,
) => {
  let didError;

  if (typeof value === 'undefined' || value?.length === 0) {
    setErrors((prev) => ({
      ...prev,
      [label]: Validations.Required,
    }));

    didError = true;
  }

  return didError;
};

export const isDate = (date: string) => {
  return (
    typeof new Date(date) === 'object' && !isNaN(new Date(date)?.valueOf())
  );
};
